import { SheetObject } from './sheetTypes';

import { selectSheetQueue } from './sheetSelectors';
import { GetState } from '../../generalTypes';
import { actionEnqueueSheet } from './sheetActions';

export const thunkEnqueueSheet =
  (sheet: SheetObject) => (dispatch: any, getState: GetState) => {
    const queueLength = selectSheetQueue(getState()).length;
    const hasBackButton = queueLength >= 1;
    const modifiedSheet = { ...sheet, hasBackButton };
    dispatch(actionEnqueueSheet(modifiedSheet));
  };
